import { motion } from "framer-motion";
import { CONTACT } from "../data/site";

const links = [
  { label: "Work", href: "#work" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
];

export const Navbar = () => (
  <motion.header
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5"
  >
    <nav className="max-w-7xl mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
      <div data-testid="nav-logo" className="group font-display font-black text-[1.35rem] tracking-[-0.06em] leading-none flex items-baseline select-none">
        arnav
        <span className="relative ml-1.5 inline-block w-2.5 h-2.5" aria-hidden="true">
          <motion.span
            initial={{ x: 14, opacity: 0 }}
            animate={{ x: 4, opacity: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.7 }}
            className="absolute inset-0"
          >
            <span className="absolute inset-0 rounded-full bg-[#FFB6C1] transition-transform duration-300 ease-out group-hover:translate-x-[-8px]" />
          </motion.span>
          <motion.span
            initial={{ x: -10, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.8 }}
            className="absolute inset-0"
          >
            <span className="absolute inset-0 rounded-full bg-[#0047FF] mix-blend-multiply transition-transform duration-300 ease-out group-hover:translate-x-[8px]" />
          </motion.span>
        </span>
      </div>
      <div className="hidden md:flex items-center gap-8">
        {links.map((l) => (
          <a
            key={l.label}
            href={l.href}
            data-testid={`nav-link-${l.label.toLowerCase()}`}
            className="text-sm font-semibold text-black/60 hover:text-[#0047FF] transition-colors"
          >
            {l.label}
          </a>
        ))}
      </div>
      <a
        href={CONTACT.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="nav-lets-talk-btn"
        className="font-display text-sm font-bold px-5 py-2.5 rounded-full bg-[#0A0A0A] text-white hover:bg-[#0047FF] transition-colors"
      >
        Let's Talk
      </a>
    </nav>
  </motion.header>
);
